import {AuthService} from "./AuthService";

export class SellerIdentityService {
    url = `seller_identities/`;

    getCampaignView(campaignId) {
        return AuthService.apiGet(this.url + "?campaign_id=" + encodeURIComponent(campaignId)).then(res => res.data.data);
    }

    refresh() {
        return AuthService.apiPost(this.url + "refresh/", {}).then(res => res.data.data);
    }

    searchSellers(marketplaceKey, query) {
        return AuthService.apiGet(this.url + "sellers/?marketplace=" + encodeURIComponent(marketplaceKey) +
            "&q=" + encodeURIComponent(query || '')).then(res => res.data.data);
    }

    link(seller, other, move) {
        return AuthService.apiPost(this.url + "link/", {seller, other, move: !!move}).then(res => res.data);
    }

    reject(seller, other) {
        return AuthService.apiPost(this.url + "reject/", {seller, other}).then(res => res.data);
    }

    storeLink(seller, marketplaceKey, url, move) {
        return AuthService.apiPost(this.url + "store_link/", {seller, marketplace_key: marketplaceKey, url, move: !!move}).then(res => res.data);
    }
}
